export default __webpack_public_path__ + "static/media/stepBlogger-5.e981226d.svg";